export function validatePriceIntersectsFirstCandle(data) {
  const { candleDuration, candleBarrier, direction, tradePlan } = data;
  if (!candleDuration || candleDuration <= 0)
    return [false, 'You must enter a candle duration larger than 0'];
  if (!Number.isInteger(candleDuration))
    return [false, 'Candle Duration must be a whole number.'];

  if (tradePlan.goLong && tradePlan.goShort)
    return [
      false,
      'Price Intersects First Candle candle cannot be long and short.',
    ];
  if (!candleBarrier || candleBarrier === '' || !direction || direction === '')
    return [false, 'Candle Barrier or Direction not defined.'];

  return [true, ''];
}
